import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { setThreadId } from '../../features/assistant/assistantSlice';
import { baseQueryWithReauth } from './helpers';
import { AssistantRequest, AssistantResponse, GetStatusArgs, GetThreadArgs } from './types';

export const assistantAPI = createApi({
  reducerPath: 'assistantAPI',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 1,
  tagTypes: ['Chat'],
  endpoints: (build) => ({
    sendMessage: build.mutation<AssistantResponse, AssistantRequest>({
      query: ({ workspaceId, signal, ...body }) => ({
        url: `/api/v1/chat/${workspaceId}/threads`,
        method: 'POST',
        body,
        signal,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data: newThreadData } = await queryFulfilled;

          dispatch(setThreadId(newThreadData.thread_id));
        } catch (error) {
          console.error('Failed to update cache with new thread id:', error);
        }
      },
    }),
    getThread: build.query<AssistantResponse, GetThreadArgs>({
      query: ({ workspaceId, thread_id, signal }) => ({
        url: `/api/v1/chat/${workspaceId}/threads/${thread_id}/messages`,
        method: 'GET',
        signal,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data: newThreadData } = await queryFulfilled;

          dispatch(setThreadId(newThreadData.thread_id));
        } catch (error) {
          console.error('Failed to update cache with new thread id:', error);
        }
      },
    }),
    getStatus: build.query<boolean, GetStatusArgs>({
      query: ({ workspaceId, signal }) => ({
        url: `/api/v1/chat/${workspaceId}/status`,
        method: 'GET',
        signal,
      }),
      transformErrorResponse: (baseQueryReturnValue) => {
        if (baseQueryReturnValue.status !== 200) {
          return false;
        }

        return baseQueryReturnValue;
      },
    }),
  }),
});

export const { useSendMessageMutation, useLazyGetThreadQuery, useGetStatusQuery } = assistantAPI;
